export enum PhxDataTableStateSavingMode {
    None = 0,
    Automatic = 1,
    Customizable = 2,
}
